import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Button } from '@astryxdesign/core/Button';
import { Icon } from '@astryxdesign/core/Icon';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';

export function NotFoundPage({ homeHref = '/' }: { homeHref?: string }) {
  return (
    <Center minHeight="100dvh" padding={6}>
      <EmptyState
        headingLevel={1}
        icon={<Icon icon={MagnifyingGlassIcon} size="lg" />}
        title="Страница не найдена"
        description="Проверьте ссылку или откройте главную страницу студии."
        actions={<Button label="На главную" variant="primary" href={homeHref} />}
      />
    </Center>
  );
}
